($ => {
	// Declars variables
	let noFilePlaceholder = '';
	// take the "no file placeholder" directly from the dom in order to have the correct translation
	if ($('.upload-input').length > 0) {
		noFilePlaceholder = $('.upload-input')
			.eq(0)
			.find('.upload-input__placeholder')
			.html();
	}

	// Add button
	$(document).on('click','.upload-input .upload-input__button_add',e => {
		// prevent the form from sending
		e.preventDefault();
		// declare vars
		const $currentTarget = $(e.currentTarget);
		const $context = $currentTarget.closest('.upload-input');
		const $input = $context.find('input');
		// make the action
		$input.trigger('click');
	});

	// Remove button
	$('.upload-input .upload-input__button_remove').click(e => {
		// prevent the form from sending
		e.preventDefault();
		// declare vars
		const $currentTarget = $(e.currentTarget);
		const $context = $currentTarget.closest('.upload-input');
		const $input = $context.find('input');
		// make the action
		$input.val('');
		$input.trigger('change');
		$context.removeClass('upload-input_completed');
	});

	$(document).on('change','.upload-input input',e => {
		const $currentTarget = $(e.currentTarget);
		const $context = $currentTarget.closest('.upload-input');
		const $placeholder = $context.find('.upload-input__placeholder');
		let placeholder = noFilePlaceholder;
		if ($currentTarget[0].files && $currentTarget[0].value) {
			placeholder = $currentTarget[0].value.split('\\').pop();
			$context.addClass('upload-input_completed');
		}
		$placeholder.html(placeholder);
	});
})(jQuery);
